import { render, staticRenderFns } from "./books.vue?vue&type=template&id=344cf4f3&scoped=true&"
import script from "./books.vue?vue&type=script&lang=js&"
export * from "./books.vue?vue&type=script&lang=js&"
import style0 from "./books.vue?vue&type=style&index=0&id=344cf4f3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "344cf4f3",
  null
  
)

export default component.exports